import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Swal from 'sweetalert2';
import { FiEdit, FiPlus } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';

const fields = [
  { name: 'denomination', label: 'Dénomination' },
  { name: 'adresse', label: 'Adresse' },
  { name: 'telfix1', label: 'Tel Fixe 1' },
  { name: 'telfix2', label: 'Tel Fixe 2' },
  { name: 'telmob1', label: 'Tel Mobile 1' },
  { name: 'telmob2', label: 'Tel Mobile 2' },
  { name: 'email', label: 'Email' },
  { name: 'siteweb', label: 'Site web' },
  { name: 'bic', label: 'BIC' },
  { name: 'ncp', label: 'N° Compte' },
  { name: 'logo', label: 'Logo (URL)' },
  { name: 'civilite_responsable', label: 'Civilité Responsable' },
  { name: 'nom_responsable', label: 'Nom Responsable' },
  { name: 'prenom_responsable', label: 'Prénom Responsable' },
  { name: 'titre_responsable', label: 'Titre Responsable' },
  { name: 'ville', label: 'Ville' },
];

const emptyForm = Object.fromEntries(fields.map(f => [f.name, '']));

const EtablissementPage = () => {
 // const { user } = useAuth();
  const [etab, setEtab] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(true);

  const fetchEtab = async () => {
    setLoading(true);
    try {
      const res = await api.get('/etablissement');
      setEtab(res.data.data || null);
    } catch {
      setEtab(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEtab();
  }, []);

  const handleEdit = () => {
    setForm(etab ? { ...etab } : emptyForm);
    setModalOpen(true);
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      for (const key in form) {
        if (key === 'logo' && form.logo instanceof File) {
          formData.append('logo', form.logo);
        } else {
          formData.append(key, form[key]);
        }
      }
      if (etab && etab.id) {
        await api.put(`/etablissement/${etab.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        await api.post('/etablissement', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      setModalOpen(false);
      fetchEtab();
      Swal.fire('Succès', "Les informations de l'établissement ont été enregistrées.", 'success');
    } catch {
      Swal.fire('Erreur', "Erreur lors de l'enregistrement.", 'error');
    }
  };

  if (loading) return <div>Chargement...</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">Informations de l'établissement</h1>
        <ConditionalButton
          entity="etablissement"
          permission={etab ? "update" : "create"}
          className="px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700 flex items-center gap-2"
          onClick={handleEdit}
        >
          {etab ? <><FiEdit /> Modifier</> : <><FiPlus /> Ajouter</>}
        </ConditionalButton>
      </div>
      <div className="bg-white p-6 rounded-lg shadow mb-6">
        {etab ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {fields.map(f => (
              <div key={f.name} className="mb-2">
                <div className="text-xs text-gray-500">{f.label}</div>
                <div className="font-medium">{etab[f.name] || <span className="text-gray-300">-</span>}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-gray-500 italic">Aucune information enregistrée.</div>
        )}
      </div>
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-3xl">
            <h2 className="text-lg font-semibold mb-4">{etab ? 'Modifier' : 'Ajouter'} les informations de l'établissement</h2>
            <form onSubmit={handleModalSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {fields.map(f => (
                  <div key={f.name}>
                    <label className="block text-sm font-medium mb-1">{f.label}</label>
                    {f.name === 'logo' ? (
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png,.svg"
                        onChange={e => setForm({ ...form, logo: e.target.files[0] })}
                        className="w-full border rounded px-3 py-2"
                      />
                    ) : (
                      <input
                        type="text"
                        name={f.name}
                        value={form[f.name] || ''}
                        onChange={e => setForm({ ...form, [f.name]: e.target.value })}
                        className="w-full border rounded px-3 py-2"
                      />
                    )}
                  </div>
                ))}
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Annuler</button>
                <ConditionalButton
                  entity="etablissement"
                  permission={etab ? "update" : "create"}
                  type="submit"
                  className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700"
                >
                  Enregistrer
                </ConditionalButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EtablissementPage;
